'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleSavedSearchEmail = exports.submitDeleteSavedSearch = exports.fetchSavedSearchesIfNeeded = exports.getSavedSearchesCount = exports.getFilteredSavedSearches = exports.isSavedSearchesLoading = exports.getSavedSearches = exports.UNSUBSCRIBE_SAVED_SEARCH_SUCCESS = exports.UNSUBSCRIBE_SAVED_SEARCH_REQUEST = exports.UNSUBSCRIBE_SAVED_SEARCH_FAIL = exports.SUBSCRIBE_SAVED_SEARCH_SUCCESS = exports.SUBSCRIBE_SAVED_SEARCH_REQUEST = exports.SUBSCRIBE_SAVED_SEARCH_FAIL = exports.LOAD_SAVED_SEARCHES_SUCCESS = exports.LOAD_SAVED_SEARCHES_REQUEST = exports.LOAD_SAVED_SEARCHES_FAIL = exports.DELETE_SAVED_SEARCH_SUCCESS = exports.DELETE_SAVED_SEARCH_REQUEST = exports.DELETE_SAVED_SEARCH_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _user = require('../modules/user');

var _config = require('../modules/config');

var _analytics = require('./analytics');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _pagination = require('../../utils/pagination');

var _savedSearchFacets = require('../modules/savedSearchFacets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var DELETE_SAVED_SEARCH_FAIL = exports.DELETE_SAVED_SEARCH_FAIL = 'la/user/savedSearches/DELETE_FAIL';
var DELETE_SAVED_SEARCH_REQUEST = exports.DELETE_SAVED_SEARCH_REQUEST = 'la/user/savedSearches/DELETE_REQUEST';
var DELETE_SAVED_SEARCH_SUCCESS = exports.DELETE_SAVED_SEARCH_SUCCESS = 'la/user/savedSearches/DELETE_SUCCESS';

var LOAD_SAVED_SEARCHES_FAIL = exports.LOAD_SAVED_SEARCHES_FAIL = 'la/user/savedSearches/LOAD_FAIL';
var LOAD_SAVED_SEARCHES_REQUEST = exports.LOAD_SAVED_SEARCHES_REQUEST = 'la/user/savedSearches/LOAD_REQUEST';
var LOAD_SAVED_SEARCHES_SUCCESS = exports.LOAD_SAVED_SEARCHES_SUCCESS = 'la/user/savedSearches/LOAD_SUCCESS';

var SUBSCRIBE_SAVED_SEARCH_FAIL = exports.SUBSCRIBE_SAVED_SEARCH_FAIL = 'la/user/savedSearches/SUBSCRIBE_FAIL';
var SUBSCRIBE_SAVED_SEARCH_REQUEST = exports.SUBSCRIBE_SAVED_SEARCH_REQUEST = 'la/user/savedSearches/SUBSCRIBE_REQUEST';
var SUBSCRIBE_SAVED_SEARCH_SUCCESS = exports.SUBSCRIBE_SAVED_SEARCH_SUCCESS = 'la/user/savedSearches/SUBSCRIBE_SUCCESS';

var UNSUBSCRIBE_SAVED_SEARCH_FAIL = exports.UNSUBSCRIBE_SAVED_SEARCH_FAIL = 'la/user/savedSearches/UNSUBSCRIBE_FAIL';
var UNSUBSCRIBE_SAVED_SEARCH_REQUEST = exports.UNSUBSCRIBE_SAVED_SEARCH_REQUEST = 'la/user/savedSearches/UNSUBSCRIBE_REQUEST';
var UNSUBSCRIBE_SAVED_SEARCH_SUCCESS = exports.UNSUBSCRIBE_SAVED_SEARCH_SUCCESS = 'la/user/savedSearches/UNSUBSCRIBE_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    loaded: 0,
    loading: false,
    searches: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var searches = void 0;

    switch (action.type) {
        case LOAD_SAVED_SEARCHES_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_SAVED_SEARCHES_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_SAVED_SEARCHES_SUCCESS:
            return (0, _extends3.default)({}, state, {
                loaded: action.meta.actionTime,
                loading: false,
                searches: action.payload
            });
        case DELETE_SAVED_SEARCH_REQUEST:
            searches = [];
            (0, _cloneDeep2.default)(state.searches).forEach(function (x) {
                if (x.savedSearchId !== action.payload) {
                    searches.push(x);
                }
            });

            return (0, _extends3.default)({}, state, {
                searches: searches
            });
        case SUBSCRIBE_SAVED_SEARCH_REQUEST:
            searches = (0, _cloneDeep2.default)(state.searches);
            searches.forEach(function (x) {
                if (x.savedSearchId === action.payload) {
                    x.sendAlert = true;
                }
            });

            return (0, _extends3.default)({}, state, {
                searches: searches
            });
        case UNSUBSCRIBE_SAVED_SEARCH_REQUEST:
            searches = (0, _cloneDeep2.default)(state.searches);
            searches.forEach(function (x) {
                if (x.savedSearchId === action.payload) {
                    x.sendAlert = false;
                }
            });

            return (0, _extends3.default)({}, state, {
                searches: searches
            });
        default:
            return state;
    }
}

/* SELECTORS */
var savedSearchSelector = function savedSearchSelector(state) {
    return state.user.savedSearch;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var savedSearchSearchesSelector = (0, _reselect.createSelector)(savedSearchSelector, function (savedSearch) {
    return savedSearch.searches;
});

var getSavedSearches = exports.getSavedSearches = (0, _reselect.createSelector)(savedSearchSearchesSelector, function (savedSearches) {
    return savedSearches;
});

var getSavedSearchById = (0, _reselect.createSelector)([savedSearchSearchesSelector, idSelector], function (savedSearches, id) {
    return savedSearches.find(function (x) {
        return x.savedSearchId === id;
    });
});

var getLoadTimeForSavedSearches = (0, _reselect.createSelector)(savedSearchSelector, function (savedSearch) {
    return savedSearch.loaded || 0;
});

var isSavedSearchesLoading = exports.isSavedSearchesLoading = (0, _reselect.createSelector)(savedSearchSelector, function (savedSearch) {
    return savedSearch.loading || false;
});

var shouldFetchSavedSearches = function shouldFetchSavedSearches(state) {
    var loaded = getLoadTimeForSavedSearches(state);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;
    return !isSavedSearchesLoading(state);
};

// sort/ filtering
var savedSearchSortAscending = function savedSearchSortAscending() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var aFacetString = (0, _savedSearchFacets.toFacetString)(a.facets).toLowerCase();
    var bFacetString = (0, _savedSearchFacets.toFacetString)(b.facets).toLowerCase();
    if (bFacetString > aFacetString) {
        return -1;
    } else if (aFacetString > bFacetString) {
        return 1;
    }
    return 0;
};

var compareFunctions = {
    LAST_SENT_ASCENDING: function LAST_SENT_ASCENDING() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!a || !a.lastSent || !a.lastSent) return 1;
        if (!b || !b.lastSent || !b.lastSent) return -1;
        return a.lastSent === b.lastSent ? savedSearchSortAscending(a, b) : Date.parse(a.lastSent) - Date.parse(b.lastSent);
    },
    LAST_SENT_DESCENDING: function LAST_SENT_DESCENDING() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!a || !a.lastSent || !a.lastSent) return 1;
        if (!b || !b.lastSent || !b.lastSent) return -1;
        return a.lastSent === b.lastSent ? savedSearchSortAscending(a, b) : Date.parse(b.lastSent) - Date.parse(a.lastSent);
    },
    SEARCH_TERM_ASCENDING: function SEARCH_TERM_ASCENDING() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return savedSearchSortAscending(a, b);
    },
    SEARCH_TERM_DESCENDING: function SEARCH_TERM_DESCENDING() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return savedSearchSortAscending(b, a);
    }
};

var savedSearchSearchFilter = function savedSearchSearchFilter(wrapper, searchString) {
    var searchTokens = searchString.toLowerCase().trim().split(/\s/);
    var matchingTokens = searchTokens.filter(function (token) {
        var facetString = (0, _savedSearchFacets.toFacetString)(wrapper.facets);
        return ('' + facetString).toLowerCase().includes(token);
    });
    var doesMatch = matchingTokens.length === searchTokens.length;
    return doesMatch;
};

var getFilteredSavedSearches = exports.getFilteredSavedSearches = function getFilteredSavedSearches(state) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        page = _ref.page,
        searchTerms = _ref.searchTerms;

    var sortOrder = arguments[2];
    var pageSize = arguments[3];

    var items = getSavedSearches(state);
    var loadedItems = items.filter(function (item) {
        return !(0, _isEmpty2.default)(item);
    });
    var loadedItemsCount = loadedItems.length;
    var filteredItems = searchTerms ? loadedItems.filter(function (itemWrapper) {
        return savedSearchSearchFilter(itemWrapper, searchTerms);
    }) : loadedItems;
    var sortedItems = sortOrder ? filteredItems.sort(compareFunctions[sortOrder]) : filteredItems;
    return {
        filteredCount: filteredItems.length || 0,
        items: (0, _pagination.pageSlicer)(sortedItems, pageSize, page) || [],
        loadedItemsCount: loadedItemsCount,
        totalCount: items.length || 0
    };
};

var getSavedSearchesCount = exports.getSavedSearchesCount = function getSavedSearchesCount(state) {
    var items = getSavedSearches(state);

    return items.length;
};

/* ACTION CREATORS */
var fetchSavedSearchesIfNeeded = exports.fetchSavedSearchesIfNeeded = function fetchSavedSearchesIfNeeded(force) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!(force || shouldFetchSavedSearches(state))) {
                                _context.next = 15;
                                break;
                            }

                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context.prev = 4;

                            dispatch({
                                type: LOAD_SAVED_SEARCHES_REQUEST
                            });
                            _context.next = 8;
                            return _api.SaveSearch.fetchSavedSearches({ authToken: authToken, deployment: deployment });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_SAVED_SEARCHES_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](4);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_SAVED_SEARCHES_FAIL
                            });

                        case 15:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[4, 12]]);
        }));

        return function (_x14, _x15) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var submitDeleteSavedSearch = exports.submitDeleteSavedSearch = function submitDeleteSavedSearch(savedSearchId) {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, authToken, deployment, analytics, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            analytics = (0, _analytics.getUnfollowSearchAnalytics)();
                            _context2.prev = 4;

                            dispatch({
                                payload: savedSearchId,
                                type: DELETE_SAVED_SEARCH_REQUEST
                            });
                            _context2.next = 8;
                            return _api.SaveSearch.postDeleteSavedSearches({
                                authToken: authToken,
                                deployment: deployment,
                                savedSearchIds: [savedSearchId]
                            });

                        case 8:
                            response = _context2.sent;

                            dispatch({
                                meta: (0, _extends3.default)({ actionTime: Date.now() }, analytics, { savedSearchId: savedSearchId }),
                                payload: response.data,
                                type: DELETE_SAVED_SEARCH_SUCCESS
                            });
                            _context2.next = 15;
                            break;

                        case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2['catch'](4);

                            dispatch({
                                error: true,
                                meta: { savedSearchId: savedSearchId },
                                payload: _context2.t0,
                                type: DELETE_SAVED_SEARCH_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[4, 12]]);
        }));

        return function (_x16, _x17) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var toggleSavedSearchEmail = exports.toggleSavedSearchEmail = function toggleSavedSearchEmail(savedSearchId) {
    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
            var state, authToken, deployment, search, response, _response;

            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            search = getSavedSearchById(state, savedSearchId);

                            if (!search.sendAlert) {
                                _context3.next = 18;
                                break;
                            }

                            dispatch({
                                payload: savedSearchId,
                                type: UNSUBSCRIBE_SAVED_SEARCH_REQUEST
                            });
                            _context3.prev = 6;
                            _context3.next = 9;
                            return _api.SaveSearch.postUnsubscribeFromSavedSearches({
                                authToken: authToken,
                                deployment: deployment,
                                savedSearchIds: [savedSearchId]
                            });

                        case 9:
                            response = _context3.sent;

                            dispatch({
                                meta: { savedSearchId: savedSearchId },
                                payload: response.data,
                                type: UNSUBSCRIBE_SAVED_SEARCH_SUCCESS
                            });
                            _context3.next = 16;
                            break;

                        case 13:
                            _context3.prev = 13;
                            _context3.t0 = _context3['catch'](6);

                            dispatch({
                                error: true,
                                meta: { savedSearchId: savedSearchId },
                                payload: _context3.t0,
                                type: UNSUBSCRIBE_SAVED_SEARCH_FAIL
                            });

                        case 16:
                            _context3.next = 29;
                            break;

                        case 18:
                            dispatch({
                                payload: savedSearchId,
                                type: SUBSCRIBE_SAVED_SEARCH_REQUEST
                            });
                            _context3.prev = 19;
                            _context3.next = 22;
                            return _api.SaveSearch.postSubscribeToSavedSearches({
                                authToken: authToken,
                                deployment: deployment,
                                savedSearchIds: [savedSearchId]
                            });

                        case 22:
                            _response = _context3.sent;

                            dispatch({
                                meta: { savedSearchId: savedSearchId },
                                payload: _response.data,
                                type: SUBSCRIBE_SAVED_SEARCH_SUCCESS
                            });
                            _context3.next = 29;
                            break;

                        case 26:
                            _context3.prev = 26;
                            _context3.t1 = _context3['catch'](19);

                            dispatch({
                                error: true,
                                meta: { savedSearchId: savedSearchId },
                                payload: _context3.t1,
                                type: SUBSCRIBE_SAVED_SEARCH_FAIL
                            });

                        case 29:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined, [[6, 13], [19, 26]]);
        }));

        return function (_x18, _x19) {
            return _ref4.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/savedSearch.js
// module id = qWId
// module chunks = 46